import { Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss']
})
export class MenuComponent {

	constructor(private sharedService:SharedService) { }

	actions = [
		{
			icon: 'search',
			label: 'Neue Suche',
			query: { a: 1 },
		},
		{
			icon: 'arrow-upload',
			label: 'Neuer import',
			query: { a: 2 },
		}];

	sendMessage(actionLabel: string): void {
		this.sharedService.sendMessage(actionLabel);
	}
}
